import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export function createStudioShellI18n(shellTranslations: Record<string, string>) {
  const instance = i18n.createInstance()
  void instance.use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['components'],
    defaultNS: 'components',
    resources: { en: { components: shellTranslations } },
    keySeparator: false,
    nsSeparator: false,
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
  })
  return instance
}
